/* eslint-disable react/jsx-props-no-spreading */
import { Button, ButtonLink, Link } from '@coop/components';
import classNames from 'classnames';

import styles from './Autocomplete.module.scss';

interface AutocompleteProps {
    query?: string;
    hints: string[];
    label: string;
    labelClassName?: string;
    renderHint: (hint: string) => React.ReactNode;
    className?: string;
}

export const AutocompleteLink = (props: React.ComponentPropsWithRef<typeof Link>) => {
    return (
        <Link {...props} className={classNames(styles.Item, props.className)}>
            {props.children}
        </Link>
    );
};

export const AutocompleteButton = (props: React.ComponentPropsWithRef<typeof Button>) => {
    return (
        <Button
            size="small"
            theme="outlined"
            {...props}
            className={classNames(styles.Button, props.className)}
        >
            {props.children}
        </Button>
    );
};

export const AutocompleteButtonLink = (props: React.ComponentPropsWithRef<typeof ButtonLink>) => {
    return (
        <ButtonLink
            size="small"
            theme="outlined"
            {...props}
            className={classNames(styles.Button, props.className)}
        >
            {props.children}
        </ButtonLink>
    );
};

const Autocomplete = ({
    query,
    hints,
    label,
    labelClassName,
    renderHint,
    className,
}: AutocompleteProps) => {
    if (!query) return null;

    return (
        hints?.length > 0 && (
            <div className={classNames(styles.Autocomplete, className)}>
                <span className={classNames(styles.Header, labelClassName)} aria-hidden>
                    {label}:
                </span>
                <ul className={styles.UList} aria-label={label}>
                    {hints?.map((hint) => (
                        <li key={hint}>{renderHint(hint)}</li>
                    ))}
                </ul>
            </div>
        )
    );
};

export default Autocomplete;
